export default "__VITE_ASSET__Dexxly_P__"